import { AnyDocument } from '../../../../types';
import { Entity } from '../../../../types/utility';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPatch } from '../../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const patchApplication = async (
  constructPatch: ConstructPatch,
  uuid: string,
  definitionName: string,
  data: Entity,
): Promise<NonPaginatedResponse<AnyDocument> | undefined> =>
  constructPatch(
    `${APPLICATION_BASE_PATH}/${uuid}`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
